import React from 'react'
import {connect} from 'react-redux'
import {Form, actions,} from 'react-redux-form'
import {Row, Col, Button} from 'react-bootstrap'
import RequiredInput from '../../../../common/form/elements/required-input'
import ImageUpload from '../../../../common/form/elements/image-upload';
import ArrowButton from '../../../../common/button-arrow'
import {saveCategory, updateCategory} from '../../../../../actions/categories'

const EditCategoryForm = ({dispatch, category, formValid}) => {

  const onSubmit = (payLoad) => {
    if (category.id) {
      dispatch(actions.submitFields('deep.admin_category', updateCategory(category.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_category', saveCategory(payLoad)));
    }
  };

  let image = undefined;

  if (category) {
    const attributes = category.attributes;
    image = attributes.links ? attributes.links.photo : undefined;
  }

  return (
    <Form model="deep.admin_category" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput label="Name"
                         placeholder="Name"
                         model='.name'
                         controlId='name'/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ImageUpload source={image}
                       sizeLimit={1024 * 1024}
                       type={['image/png', 'image/jpg', 'image/jpeg']}
                       model=".photo"
                       required/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton color="grey"
                       className="pull-right"
                       disabled={!formValid}>Save</ArrowButton>
        </Col>
      </Row>
    </Form>
  )
};

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_category.$form.valid
  };
};

export default connect(mapStateToProps)(EditCategoryForm);



// WEBPACK FOOTER //
// ./src/components/admin/products/categories/edit/category-edit-form.jsx